import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconMaterialV2: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 2C6.34315 2 5 3.34315 5 5V21C5 21.3466 5.17945 21.6684 5.47427 21.8507C5.76909 22.0329 6.13723 22.0494 6.44721 21.8944L12 19.118L17.5528 21.8944C17.8628 22.0494 18.2309 22.0329 18.5257 21.8507C18.8205 21.6684 19 21.3466 19 21V5C19 3.34315 17.6569 2 16 2H8Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconMaterialV2;
